<template>
  <div class="imgListNew3n">
    <div class="g-box">
      <div class="imgListNew3n-list">
        <router-link
          v-for="(item, index) in list"
          :key="index"
          class="list-item m-h"
          :to="'/info/' + item.id"
        >
          <div
            class="list-img"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          ></div>
          <div class="list-cont">
            <div class="list-cap">{{ item.title }}</div>
            <!--            <div class="list-tit">{{ item.tips }}</div>-->
          </div>
        </router-link>
      </div>
      <el-pagination
        @current-change="onCurrentChange"
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        class="m-pagination"
      />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    }
  }
};
</script>
<style lang="less">
.imgListNew3n {
  padding: 109px 0;
}
.imgListNew3n-list {
  display: flex;
  flex-wrap: wrap;
  .list-item {
    display: block;
    width: 360px;
    flex-shrink: 0;
    margin-bottom: 48px;
    margin-right: 60px;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  .list-img {
    height: 240px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 4px;
    position: relative;
  }
  .list-cont {
    padding: 24px 16px 0 16px;
  }
  .list-cap {
    color: #282828;
    font-size: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    padding-bottom: 20px;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 50px;
      height: 4px;
      margin-left: -25px;
      background: rgba(82, 151, 224, 1);
    }
  }
  .list-tit {
    color: #979797;
    font-size: 16px;
    margin-top: 16px;
  }
}
</style>
